import { useClerk } from '@clerk/react-router';
import { APP_PATHS } from 'app-shared/constants';
import { useEffect } from 'react';

import { isSignedOutState } from '@/session/states/isSignedOutState';
import { useSetAtomState } from '@/ui/utilities/state/jotai/hooks/useSetAtomState';

// The API refused the session (UNAUTHENTICATED) although Clerk still had one:
// ending it and opening the sign-in page avoids a loop between the two.
export const ClerkSignOutEffect = () => {
  const { signOut } = useClerk();
  const setIsSignedOut = useSetAtomState(isSignedOutState);

  useEffect(() => {
    void signOut({ redirectUrl: APP_PATHS.signIn }).finally(() => {
      setIsSignedOut(false);
    });
  }, [signOut, setIsSignedOut]);

  return null;
};
